module.exports = __webpack_public_path__ + "img/3.ef9f724f.png";